import { createApi } from '@reduxjs/toolkit/query/react';
import { ogBaseQuery } from '../../ogBaseQuery';

export enum ManageableFeatureKey {
  CheckInPhotoCapture = 'CHECK_IN_PHOTO_CAPTURE',
}

type ManageableFeature = {
  key: ManageableFeatureKey;
  isEnabled: boolean | null;
};

export const userManageableFeatures = createApi({
  baseQuery: ogBaseQuery(),
  reducerPath: 'userManageableFeaturesOG',
  tagTypes: ['userFeatures'],
  endpoints: (builder) => ({
    getUserFeatures: builder.query<
      ManageableFeature[],
      { userId: string; institutionId?: number }
    >({
      query: (data) => {
        return {
          url: `userManageableFeatures`,
          method: 'GET',
          params: {
            userId: data.userId,
            institutionId: data.institutionId,
          },
        };
      },
      providesTags: ['userFeatures'],
    }),
    setUserFeatures: builder.mutation<
      unknown,
      {
        userId: string;
        featureKey: ManageableFeatureKey;
        isEnabled: boolean;
        institutionId?: number;
      }
    >({
      query: (data) => {
        return {
          url: `userManageableFeatures/${data.featureKey}`,
          method: 'PUT',
          params: {
            userId: data.userId,
            isEnabled: data.isEnabled,
            institutionId: data.institutionId,
          },
        };
      },
      invalidatesTags: ['userFeatures'],
    }),
  }),
});

export const {
  endpoints: { getUserFeatures, setUserFeatures },
  useGetUserFeaturesQuery,
  useSetUserFeaturesMutation,
  useLazyGetUserFeaturesQuery,
} = userManageableFeatures;
